import $ from "../wangeditor/js/util/dom-core.js";
import rotateOssurl from "../utils/rotateOssUrl.js";

export default {
  methods: {
    onStart({ file, e }) {
      this.insertImage(file);
    },
    onSuccess({ file, e }) {
      $(`#editor-img-${file.id}`)
        .attr("src", file.url)
        .removeClass("editor-img-uploading");
      $(`#editor-progress-${file.id}`).remove();
    },
    onProgress({ file, e }) {
      let el = $(`#editor-progress-${file.id}`);
      if (el) {
        el.html(Math.floor(file.percentage) + "%");
      }
    },
    insertImage(file) {
      let template = `
     <p><img width="260" src="${
       file.url
     }" class="image-holder editor-img-uploading" data-img-id="${
        file.id
      }" id="editor-img-${file.id}" /></p>
      <p id="editor-progress-${file.id}">0%</p>
      <p><br></p>

     `;
      this.editor.cmd.do("insertHtml", template);
      // this.editor.cmd.do("insertHtml", "<p></p>");
    },
    deleteImg(params) {
      let id = params.id;
      $("#" + id).remove();
    },
    rotateImg(params) {
      let id = params.id;
      let url = $("#" + id).attr("src");
      $("#" + id).attr("src", rotateOssurl({ url: url, orient: "right" }));
    },
    enlargeImg(params) {
      let id = params.id;
      $("#" + id).attr("width", "100%");
    },
    shrinkImg(params) {
      let id = params.id;
      $("#" + id).attr("width", "260px");
    },
    alignImgLeft(params) {
      let id = params.id;
      $("#" + id)
        .parent("p")
        .css("text-align", "");
    },
    alignImgCenter(params) {
      let id = params.id;
      $("#" + id)
        .parent("p")
        .css("text-align", "center");
    },
    alignImgRight(params) {
      let id = params.id;
      $("#" + id)
        .parent("p")
        .css("text-align", "right");
    }
  }
};
